/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
export const FETCH_OVER_VIEW_DETAILS_REQUEST =
  "FETCH_OVER_VIEW_DETAILS_REQUEST";
export const FETCH_OVER_VIEW_DETAILS_SUCCESS =
  "FETCH_OVER_VIEW_DETAILS_SUCCESS";
export const FETCH_OVER_VIEW_DETAILS_FAILURE =
  "FETCH_OVER_VIEW_DETAILS_FAILURE";
export const FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST =
  "FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST";
export const FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS =
  "FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS";
export const FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE =
  "FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE";
